import {combineReducers} from 'redux'
import UserProfileContainer from './components/UserProfileContainer';

import userProfileReducers from './reducers/userProfileReducers';

const components = { UserProfileContainer };

const reducers = combineReducers({
  userProfile: userProfileReducers,
});

export { components, reducers };